// extracted by mini-css-extract-plugin
export default {"images":"styles_images__bnz9G","image":"styles_image__eYVI0","moreTitle":"styles_moreTitle__XZHf0","moreBackdrop":"styles_moreBackdrop__iM7IG"};